import { Check } from "lucide-react";
import { cn } from "@/lib/cn";

export type ItemDaBaseNoLab = { id: string; nome: string; grupo: string; detalhe: string | null; sugerido: boolean; jaTem: boolean };

/** Itens da base agrupados; o que o laboratório já tem aparece travado. */
export function ListaDaBase({
  itens,
  marcados,
  onMarcar,
}: {
  itens: ItemDaBaseNoLab[];
  marcados: Set<string>;
  onMarcar: (ids: string[], marcar: boolean) => void;
}) {
  const grupos = [...new Set(itens.map((i) => i.grupo))];
  return (
    <div className="space-y-3">
      {grupos.map((g) => {
        const doGrupo = itens.filter((i) => i.grupo === g);
        const livres = doGrupo.filter((i) => !i.jaTem);
        const todos = livres.length > 0 && livres.every((i) => marcados.has(i.id));
        return (
          <section key={g}>
            <div className="mb-1 flex items-center justify-between gap-2 px-1">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-zinc-500 dark:text-muted-foreground">{g}</p>
              {livres.length > 1 && (
                <button
                  type="button"
                  onClick={() => onMarcar(livres.map((i) => i.id), !todos)}
                  className="text-[11px] font-medium text-brand-700 hover:underline dark:text-primary"
                >
                  {todos ? "Desmarcar todos" : "Marcar todos"}
                </button>
              )}
            </div>
            <div className="divide-y divide-zinc-100 overflow-hidden rounded-lg border border-zinc-200 dark:divide-border dark:border-border">
              {doGrupo.map((i) => {
                const marcado = marcados.has(i.id);
                return (
                  <button
                    key={i.id}
                    type="button"
                    disabled={i.jaTem}
                    onClick={() => onMarcar([i.id], !marcado)}
                    aria-pressed={marcado}
                    className={cn(
                      "flex w-full items-center gap-3 px-3 py-2 text-left text-sm transition-colors",
                      i.jaTem ? "cursor-default bg-zinc-50/70 dark:bg-muted/30" : "hover:bg-zinc-50 dark:hover:bg-muted",
                    )}
                  >
                    <span
                      className={cn(
                        "flex h-4 w-4 shrink-0 items-center justify-center rounded border",
                        marcado || i.jaTem ? "border-brand-600 bg-brand-600 text-white" : "border-zinc-300 dark:border-border",
                        i.jaTem && "opacity-40",
                      )}
                    >
                      {(marcado || i.jaTem) && <Check className="h-3 w-3" />}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className={cn("block truncate", i.jaTem ? "text-zinc-400" : "text-zinc-900 dark:text-foreground")}>{i.nome}</span>
                      {i.detalhe && <span className="block truncate text-[11.5px] text-zinc-500 dark:text-muted-foreground">{i.detalhe}</span>}
                    </span>
                    {i.jaTem ? (
                      <span className="shrink-0 text-[11px] text-zinc-400">Já no catálogo</span>
                    ) : (
                      i.sugerido && (
                        <span className="shrink-0 rounded-full bg-brand-50 px-2 py-0.5 text-[10.5px] font-semibold text-brand-700 dark:bg-primary/10 dark:text-primary">
                          Sugerido
                        </span>
                      )
                    )}
                  </button>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
}
